import { DocProperty } from 'typescript-openapi-router';

export class LastCleanDateRequestBody {
  @DocProperty({
    type: 'string',
    isRequired: false,
  })
  lastInsectCleanedAt?: string;
}
